import React from 'react';

import styles from '../style/components/LogoHeader.module.scss';

const LogoHeader = () => <header className={styles.header} />;

export default LogoHeader;
